import BossModel from "@/models/BossModel";

export default class PackageInternalTagType extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/internal-tag/type';

    /**
     *
     * @type {string}
     */
    static entity = 'packageInternalTagTypes';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new PackageInternalTagType(data[key]));
            }
            return instances;
        });
    }

    /**
     * @param params
     * @returns {*}
     */
    static fetchAllForSelect(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get(true);
    }
}
